import { Handle, Position, useStore } from "@xyflow/react";
import React from "react";
import { useWhiteboard } from "./WhiteboardContext";

const SIDES = [
  [Position.Top, "top"],
  [Position.Right, "right"],
  [Position.Bottom, "bottom"],
  [Position.Left, "left"],
] as const;

// React Flow won't draw a line to a node with no handles, so these are always
// rendered, just hidden and inert when the board is read-only or a drawing
// tool is in use.
const inertStyle = { opacity: 0, pointerEvents: "none" as const };

// One handle per side. The canvas uses loose connections, so any handle can
// start or end an arrow; WhiteboardEdge works out where the line meets each
// node itself. A locked node's handles only end lines: starting one from it
// is too close to grabbing it.
const NodeHandles = ({ locked = false }: { locked?: boolean }) => {
  const { readOnly } = useWhiteboard();
  const connectable = useStore((s) => s.nodesConnectable) && !readOnly;
  return (
    <>
      {SIDES.map(([position, side]) => (
        <Handle
          key={side}
          type="source"
          position={position}
          id={side}
          isConnectable={connectable}
          isConnectableStart={connectable && !locked}
          isConnectableEnd={connectable}
          style={connectable ? undefined : inertStyle}
        />
      ))}
    </>
  );
};

export default React.memo(NodeHandles);
